import { SimpleLogo } from '@apparel/react/icons/SimpleLogo';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { useNewAuthForm } from '../NewAuthFormContext';
const useStyles = makeStyles(
    () => ({
        root: {
            padding: '4px 0 0 0',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        },
        headline: {
            fontSize: 14,
            color: 'rgba(0, 0, 0, 0.6)',

            '&.change': {
                marginLeft: 34,
                marginRight: 8,
            },
        },

        header: {
            paddingTop: 10,
        },
    }),
    {
        name: 'FormHeader',
    },
);

export function FormHeader() {
    const classes = useStyles();
    const dialog$ = useNewAuthForm();

    const title =
        dialog$.cta === 'CLAIM'
            ? `${dialog$.view === 'signIn' ? `Login to ${dialog$.title}` : dialog$.title}`
            : `${dialog$.view === 'signIn' ? 'Login' : 'Sign Up'} to ${dialog$.title}`;

    return (
        <div className={classes.root}>
            <SimpleLogo height={30} />
            <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                mt={1}
                width={'100%'}
                className={classes.header}
            >
                <Typography noWrap style={{ fontWeight: 500 }} title={title} variant={'h5'}>
                    {title}
                </Typography>
            </Box>
        </div>
    );
}

export default FormHeader;
